<script>
import FetchController from './FetchController.vue'
  export default {
    extends: FetchController,
    methods: {
      search(searchQuery) {
        return this.fetchData(`/data-warga/search?q=${searchQuery}`, 'GET', null, true, false)
          .then(res => {
            return res.json()
          })
          .then(data => {
            return new Promise((resolve) => {resolve(data)})
          })
      },
      getWarga(steamHex) {
        return this.fetchData(`/data-warga/get-user?steamHex=${steamHex}`, 'GET', null, false, false)
          .then(res => {
            return res.json()
          })
          .then(data => {
            return new Promise((resolve) => {resolve(data)})
          })
      },
      postImage(steamHex, imgSrc, job, fullname) {
        return this.fetchData('/data-warga/save-image', 'POST', {steamHex, imgSrc, job, fullname}, true, false)
          .then(res => {
            if(!res.ok){
              return res.json()
            }
            return
          })
          .then(data => {
            if(data !== undefined) {
              return new Promise((resolve) => {
                resolve(data)
              })
            }
            return {status: 201}
          })
      },
      getImage(steamHex) {
        return this.fetchData(`/data-warga/get-image?steamHex=${steamHex}`, 'GET', null, true, false)
          .then(res => {
            return res.json()
          })
          .then(data => {
            return new Promise((resolve) => {
              resolve(data)
            })
          })
      },
      postNotes(steamHex, notes, job, fullname, oldNotes) {
        return this.fetchData('/data-warga/add-notes', 'POST', {steamHex, notes, job, fullname, oldNotes}, true, false)
          .then(res => {
            if(!res.ok) {
              return res.json()
            }
            return
          }) 
          .then(data => {
            if(data !== undefined) {
              return new Promise((resolve) => {
                resolve(data)
              })
            } else {
              return new Promise((resolve) => {
                resolve({status: 201})
              })
            }
          })
      },
      getDataWarga(steamHex) {
        return this.fetchData(`/data-warga/get-warga-data?steamHex=${steamHex}`, 'GET', null, true, false)
          .then(res => {
            return res.json()
          })
          .then(data => {
            return new Promise((resolve) => {
              resolve(data)
            })
          })
      },
      postPekerjaan(steamHex, job, fullname, pekerjaan) {
        return this.fetchData('/data-warga/add-pekerjaan', 'POST', {job, fullname, pekerjaan, steamHex}, true, false)
          .then(res => {
            if(!res.ok) {
              return res.json()
            }
            return
          })
          .then(data => {
            if(data !== undefined) {
              return new Promise((resolve) => {
                resolve(data)
              })
            } else {
              return new Promise((resolve) => {
                resolve({status: 201})
              })
            }
          })
      },
      postPhone(steamHex, phone, fullname, pekerjaan) {
        return this.fetchData('/data-warga/add-phone', 'POST', {phone, fullname, pekerjaan, steamHex}, true, false)
          .then(res => {
            if(!res.ok) {
              return res.json()
            }
            return
          })
          .then(data => {
            if(data !== undefined) {
              return new Promise((resolve) => {
                resolve(data)
              })
            } else {
              return new Promise((resolve) => {
                resolve({status: 201})
              })
            }
          })
      },
      getVehicle(steamHex) {
        return this.fetchData(`/data-warga/vehicle?steamHex=${steamHex}`, 'GET', null, true, false)
          .then(res => {
            return res.json();
          })
          .then(data => {
            return new Promise((resolve) => {
              resolve(data)
            })
          })
      },
      submitLisensi(steamHex, lisensi, fullname, pekerjaan, masaberlaku) {
        return this.fetchData('/data-warga/add-lisensi', 'POST', {steamHex, lisensi, fullname, pekerjaan, masaberlaku}, true, false)
          .then(res => {
            if(!res.ok) {
              return res.json();
            }
            return
          })
          .then(data => {
            if(data !== undefined) {
              return new Promise((resolve) => {
                resolve(data)
              })
            } else {
              return new Promise((resolve) => {
                resolve({status: 201})
              })
            }
          })
      },
      getLisensi(steamHex) {
        return this.fetchData(`/data-warga/get-lisensi?steamHex=${steamHex}`, 'GET', null, true, false)
          .then(res => {
            return res.json();
          })
          .then(data => {
            return new Promise((resolve) => {
              resolve(data)
            })
          })
      },
      submitKendaraan(steamHex, platNomor, fullname, pekerjaan, modelName) {
        return this.fetchData('/data-warga/add-kendaraan', 'POST', {steamHex, platNomor, fullname, pekerjaan, modelName}, true, false)
          .then(res => {
            if(!res.ok) {
              return res.json();
            }
            return
          })
          .then(data => {
            if(data !== undefined) {
              return new Promise((resolve) => {
                resolve(data)
              })
            } else {
              return new Promise((resolve) => {
                resolve({status: 201})
              })
            }
          })
      },
      getKendaraan(steamHex) {
        return this.fetchData(`/data-warga/get-kendaraan?steamHex=${steamHex}`, 'GET', null, true, false)
          .then(res => {
            return res.json();
          })
          .then(data => {
            return new Promise((resolve) => {
              resolve(data)
            })
          })
      },
      getSurat(steamHex) {
        return this.fetchData(`/surat/get-surat?steamHex=${steamHex}`, 'GET', null, true, false)
          .then(res => {
            return res.json();
          })
          .then(data => {
            return new Promise((resolve) => {
              resolve(data)
            })
          })
      },
      getSuratEditedBy(steamHex) {
        return this.fetchData(`/surat/surat-edited-by?steamHex=${steamHex}`, 'GET', null, true, false) 
          .then(res => {
            return res.json();
          })
          .then(data => {
            return new Promise((resolve) => {
              resolve(data)
            })
          })
      },
      deleteSurat(id, steamHex, fullname, pekerjaan, surattitle) {
        return this.fetchData('/surat/delete-surat', 'DELETE', {id, steamHex, fullname, pekerjaan, surattitle}, true)
          .then(res => {
            if(!res.ok) {
              return res.json()
            }
            return
          })
          .then(data => {
            if(data !== undefined) {
              return new Promise((resolve) => {
                resolve(data)
              })
            } else {
              return new Promise((resolve) => {
                resolve({status: 204})
              })
            }
          })
      },
      postGoldar(steamHex, goldar, fullname) {
        return this.fetchData('/data-warga/goldar', 'POST', {steamHex, goldar, fullname}, true, false)
          .then(res => {
            if(res.ok) {
              return
            }
            return res.json();
          })
          .then(data => {
            if(data === undefined) {
              return new Promise((resolve) => {
                resolve({status: 204})
              })
            } else {
              return new Promise((resolve) => {
                resolve(data)
              })
            }
          })
      },
      getKoma(steamHex) {
        return this.fetchData(`/data-warga/total-koma-warga?steamHex=${steamHex}`, 'GET', null, false, false)
          .then(res => {
            return res.json();
          })
          .then(data => {
            return new Promise((resolve) => {
              resolve(data)
            })
          })
      },
      saveKoma(steamHex, reason, fullname) {
        return this.fetchData('/data-warga/koma', 'POST', {steamHex, reason, fullname}, false, false)
          .then(res => {
            if(res.ok) {
              return;
            }
            return res.json();
          })
          .then(data => {
            if(data === undefined) {
              return new Promise((resolve) => {
                resolve({status: 204})
              })
            } else {
              return new Promise((resolve) => {
                resolve(data)
              })
            }
          })
      },
      getWeeklyKoma() {
        return this.fetchData('/data-warga/weekly-koma', 'GET', null, true, false)
          .then(res => {
            return res.json()
          })
          .then(data => {
            if(data.result) {
              return new Promise((resolve) => {
                resolve(data.result) // array
              })
            } else {
              return new Promise((resolve) => {
                resolve(data.msg)
              })
            }
          })
      }
    }
  }
</script>